import type {
  FormInputControl,
  FormTextAreaControl,
  FormOriginControl,
  KycAddressType,
  KycAddressControlsType,
} from 'src/types/form-config';

import { getFormDataLimit } from '../../../utils';

import { KycProps } from '../../../constants/kyc';

const home_address: FormTextAreaControl = {
  tag: 'textarea',
  placeholder: 'address',
  name: KycProps.ADDRESS_HOME,
  type: 'text',
  label: 'Address',
  validator: 'required=true, min=2, max=50, string=true',
};

const origin: FormOriginControl = {
  tag: 'origin',
  controls: {
    country: {
      tag: 'select',
      placeholder: 'country',
      name: KycProps.COUNTRY_HOME,
      type: 'text',
      label: 'Country',
      options: [],
      validator: 'required=true',
      remoteOption: true,
      optionCategory: 'COUNTRY',
      optionGetter: 'getOptionsAddress',
    },
    province: {
      tag: 'select',
      placeholder: 'province',
      name: KycProps.PROVINCE_HOME,
      type: 'text',
      label: 'Provice/ Region',
      options: [],
      validator: 'required=true',
      remoteOption: true,
      optionCategory: 'PROVINCE',
      optionGetter: 'getOptionsAddress',
    },
    city: {
      tag: 'select',
      placeholder: 'city',
      name: KycProps.CITY_HOME,
      type: 'text',
      label: 'City',
      options: [],
      validator: 'required=true',
      remoteOption: true,
      optionCategory: 'CITY',
      optionGetter: 'getOptionsAddress',
    },
  },
};

const homePostalCode: FormInputControl = {
  tag: 'input',
  placeholder: 'postal code',
  name: KycProps.POSTAL_HOME,
  type: 'text',
  label: 'Postal Code',
  validator: 'required=true, max=10, min=2, number=true',
};

const phoneNumber: FormInputControl = {
  tag: 'input',
  placeholder: 'phone number',
  name: KycProps.PHONE_HOME,
  type: 'text',
  label: 'Phone Number',
  validator: 'required=true, max=50, min=2, string=true',
};

const homeFax: FormInputControl = {
  tag: 'input',
  placeholder: 'fax number',
  name: KycProps.FAX_HOME,
  type: 'text',
  label: 'Fax Number',
  validator: 'required=true, max=50, min=2, string=true',
};

const homeInhabitPeriod: FormInputControl = {
  tag: 'input',
  placeholder: 'living in',
  name: KycProps.PERIOD_HOME,
  type: 'text',
  label: 'How long have you been living there? (years)',
  validator: 'required=true',
};

const prevHome: FormInputControl = {
  tag: 'input',
  placeholder: 'living in',
  name: KycProps.PREV_HOME,
  type: 'text',
  label: 'If recently moved in, where did you stay before',
  // validator: 'required=true',
};

const controls: KycAddressControlsType = [
  home_address,
  origin,
  homePostalCode,
  phoneNumber,
  homeFax,
  homeInhabitPeriod,
  prevHome,
];

const KycAddressData: KycAddressType = {
  name: 'address',
  display: 'Address',
  controls,
  getFormData: getFormDataLimit(controls),
};

export default KycAddressData;
